<form fxLayout="column" [formGroup]="form" class="p-3">
  <ng-container [ngSwitch]="booking.test.templateName">
    <ng-container *ngSwitchCase="'PhaST'">
      <h4 class="fs-6">
        {{ 'phast.question.university.text' | translate }}
        <div class="form-text">
          {{ 'phast.question.university.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        [field]="university"
        [options]="universityOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="true"
        [required]="false"
        [focused]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'phast.question.final-grade.text' | translate }}
        <div class="form-text">
          {{ 'phast.question.final-grade.required' | translate }}
        </div>
      </h4>

      <app-form-field-text [field]="finalGrade">
      </app-form-field-text>
    </ng-container>

    <ng-container *ngSwitchCase="'TM-WISO'">
      <h4 class="fs-6">
        {{ 'tm-wiso.questions.language.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.language.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="language"
        [options]="languageOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="false"
        [required]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'tm-wiso.questions.apply-for-university.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.apply-for-university.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="applyForUniversity"
        [options]="universityOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="true"
        [required]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'tm-wiso.questions.confirm-send-results.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.confirm-send-results.hint' | translate }}
        </div>
      </h4>

      <div class="mb-2">
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            id="confirmSendYes"
            formControlName="confirmSendResults"
            [value]="confirmSendResultsOption[0].value"
            required
          />
          <label class="form-check-label" for="confirmSendYes">
            {{ 'tm-wiso.questions.confirm-send-results.yes' | translate }}
          </label>
        </div>

        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            id="confirmSendNo"
            formControlName="confirmSendResults"
            [value]="confirmSendResultsOption[1].value"
          />
          <label class="form-check-label" for="confirmSendNo">
            {{ 'tm-wiso.questions.confirm-send-results.no' | translate }}
          </label>
        </div>
      </div>

      <h4 class="fs-6">
        {{ 'tm-wiso.questions.send-results.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.send-results.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="sendResultsToUniversities"
        [options]="sendResultsToUniversitiesOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="true"
        [required]="false"
        [disabled]="
          !confirmSendResults.valid ||
          confirmSendResults.value === 2
        "
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'tm-wiso.questions.current-university.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.current-university.not-required' | translate }}
        </div>
      </h4>
      <div
        class="mb-2"
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutGap="0"
        fxLayoutGap.gt-sm="2rem"
      >
        <app-form-field-text
          fxFlex="grow"
          [field]="currentUniversityName"
          [label]="
            'tm-wiso.questions.current-university.label.university-name'
              | translate
          "
          [required]="false"
        >
        </app-form-field-text>
        <app-form-field-text
          fxFlex="grow"
          [field]="currentUniversityPlace"
          [label]="
            'tm-wiso.questions.current-university.label.university-place'
              | translate
          "
          [required]="false"
        >
        </app-form-field-text>
      </div>

      <h4 class="fs-6">
        {{ 'tm-wiso.questions.current-subject.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.current-subject.not-required' | translate }}
        </div>
      </h4>
      <div
        class="mb-2"
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutGap="0"
        fxLayoutGap.gt-sm="2rem"
      >
        <app-form-field-text
          fxFlex="grow"
          [field]="currentStudySubject"
          [label]="
            'tm-wiso.questions.current-subject.label.study-subject'
              | translate
          "
          [required]="false"
        >
        </app-form-field-text>
        <app-form-field-text
          fxFlex="grow"
          [field]="currentTypeOfDegree"
          [label]="
            'tm-wiso.questions.current-subject.label.type-of-degree'
              | translate
          "
          [required]="false"
        >
        </app-form-field-text>
      </div>

      <h4 class="fs-6">
        {{ 'tm-wiso.questions.school-grade.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.school-grade.not-required' | translate }}
        </div>
      </h4>
      <app-form-field-text
        class="mb-2"
        fxFlex="grow"
        [field]="finalGrade"
        [label]="
          'tm-wiso.questions.school-grade.label' | translate
        "
        [required]="false"
      >
      </app-form-field-text>

      <h4 class="fs-6">
        {{ 'tm-wiso.questions.study-grade.text' | translate }}
        <div class="form-text">
          {{ 'tm-wiso.questions.study-grade.not-required' | translate }}
        </div>
      </h4>
      <app-form-field-text
        class="mb-2"
        fxFlex="grow"
        [field]="graduateDegree"
        [label]="
          'tm-wiso.questions.study-grade.label' | translate
        "
        [required]="false"
      >
      </app-form-field-text>
    </ng-container>

    <ng-container *ngSwitchCase="'GSAT'">
      <h4 class="fs-6">
        {{ 'gsat.questions.language.text' | translate }}
        <div class="form-text">
          {{ 'gsat.questions.language.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="language"
        [options]="languageOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="false"
        [required]="true"
      ></app-form-field-select>
    </ng-container>

    <ng-container *ngSwitchCase="'ITB-Business'">
      <h4 class="fs-6">
        {{ 'itb-business.questions.variant.text' | translate }} *
        <div class="form-text">
          {{ 'itb-business.questions.variant.hint' | translate }}
          <a href="{{ 'itb-business.questions.variant.link.link' | translate }}" target="_blank">{{ 'itb-business.questions.variant.link.text' | translate }}</a>
        </div>
      </h4>

      <div class="mb-2">
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            id="itbBusinessBasic"
            formControlName="selectItbBusinessVariant"
            [value]="selectItbBusinessVariantOptions[0].value"
            required
          />
          <label class="form-check-label" for="itbBusinessBasic">
            {{ 'itb-business.questions.variant.basic.part-1' | translate }}
            (<strong>{{ 'itb-business.questions.variant.basic.part-2' | translate }}</strong>
            {{ 'itb-business.questions.variant.basic.part-3' | translate }})
          </label>
        </div>

        <div class="form-check mb-3">
          <input
            type="radio"
            class="form-check-input"
            id="itbBusinessPlus"
            formControlName="selectItbBusinessVariant"
            [value]="selectItbBusinessVariantOptions[1].value"
          />
          <label class="form-check-label" for="itbBusinessPlus">
            {{ 'itb-business.questions.variant.plus.part-1' | translate }}
            (<strong>{{ 'itb-business.questions.variant.plus.part-2' | translate }}</strong>
            {{ 'itb-business.questions.variant.plus.part-3' | translate }})
          </label>
        </div>
      </div>

      <h4 class="fs-6">
        {{ 'itb-business.questions.language.text' | translate }}
        <div class="form-text">
          {{ 'itb-business.questions.language.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="language"
        [options]="languageOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="false"
        [required]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'itb-business.questions.apply-for-university.text' | translate }}
        <div class="form-text">
          {{ 'itb-business.questions.apply-for-university.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="applyForUniversity"
        [options]="universityOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="true"
        [required]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'itb-business.questions.confirm-send-results.text' | translate }}
        <div class="form-text">
          {{ 'itb-business.questions.confirm-send-results.hint' | translate }}
        </div>
      </h4>

      <div class="mb-2">
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            id="confirmSendYes"
            formControlName="confirmSendResults"
            [value]="confirmSendResultsOption[0].value"
            required
          />
          <label class="form-check-label" for="confirmSendYes">
            {{ 'itb-business.questions.confirm-send-results.yes' | translate }}
          </label>
        </div>

        <div class="form-check mb-3">
          <input
            type="radio"
            class="form-check-input"
            id="confirmSendNo"
            formControlName="confirmSendResults"
            [value]="confirmSendResultsOption[1].value"
          />
          <label class="form-check-label" for="confirmSendNo">
            {{ 'itb-business.questions.confirm-send-results.no' | translate }}
          </label>
        </div>
      </div>

      <h4 class="fs-6">
        {{ 'itb-business.questions.send-results.text' | translate }}
        <div class="form-text">
          {{ 'itb-business.questions.send-results.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="sendResultsToUniversities"
        [options]="sendResultsToUniversitiesOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="true"
        [required]="false"
        [disabled]="
          !confirmSendResults.valid ||
          confirmSendResults.value === 2
        "
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'itb-business.questions.final-grade.text' | translate }}
        <div class="form-text">
          {{ 'itb-business.questions.final-grade.required' | translate }}
        </div>
      </h4>

      <app-form-field-text
        class="mb-2"
        [field]="finalGrade"
      >
      </app-form-field-text>
    </ng-container>

    <ng-container *ngSwitchCase="'ITB-Science'">
      <h4 class="fs-6">
        {{ 'itb-science.questions.language.text' | translate }}
        <div class="form-text">
          {{ 'itb-science.questions.language.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="language"
        [options]="languageOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="false"
        [required]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'itb-science.questions.final-grade.text' | translate }}
        <div class="form-text">
          {{ 'itb-science.questions.final-grade.required' | translate }}
        </div>
      </h4>

      <app-form-field-text
        class="mb-2"
        [field]="finalGrade"
      >
      </app-form-field-text>
    </ng-container>

    <ng-container *ngSwitchCase="'ITB-Technology'">
      <h4 class="fs-6">
        {{ 'itb-technology.questions.language.text' | translate }}
        <div class="form-text">
          {{ 'itb-technology.questions.language.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="language"
        [options]="languageOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="false"
        [required]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'itb-technology.questions.apply-for-university.text' | translate }}
        <div class="form-text">
          {{ 'itb-technology.questions.apply-for-university.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="applyForUniversity"
        [options]="universityOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="true"
        [required]="true"
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'itb-technology.questions.confirm-send-results.text' | translate }}
        <div class="form-text">
          {{ 'itb-technology.questions.confirm-send-results.hint' | translate }}
        </div>
      </h4>

      <div class="mb-2">
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            id="itbTechnologyConfirmSendYes"
            formControlName="confirmSendResults"
            [value]="confirmSendResultsOption[0].value"
            required
          />
          <label class="form-check-label" for="itbTechnologyConfirmSendYes">
            {{ 'itb-technology.questions.confirm-send-results.yes' | translate }}
          </label>
        </div>

        <div class="form-check mb-3">
          <input
            type="radio"
            class="form-check-input"
            id="itbTechnologyConfirmSendNo"
            formControlName="confirmSendResults"
            [value]="confirmSendResultsOption[1].value"
          />
          <label class="form-check-label" for="itbTechnologyConfirmSendNo">
            {{ 'itb-technology.questions.confirm-send-results.no' | translate }}
          </label>
        </div>
      </div>

      <h4 class="fs-6">
        {{ 'itb-technology.questions.send-results.text' | translate }}
        <div class="form-text">
          {{ 'itb-technology.questions.send-results.required' | translate }}
        </div>
      </h4>

      <app-form-field-select
        class="mb-2"
        [field]="sendResultsToUniversities"
        [options]="sendResultsToUniversitiesOptions"
        [label]="'label.dropdown-select' | translate"
        [multiple]="true"
        [required]="false"
        [disabled]="
          !confirmSendResults.valid ||
          confirmSendResults.value === 2
        "
      ></app-form-field-select>

      <h4 class="fs-6">
        {{ 'itb-technology.questions.final-grade.text' | translate }}
        <div class="form-text">
          {{ 'itb-technology.questions.final-grade.required' | translate }}
        </div>
      </h4>

      <app-form-field-text
        class="mb-2"
        [field]="finalGrade"
      >
      </app-form-field-text>
    </ng-container>
  </ng-container>
</form>
